import { Container, Group, Stack, Title } from "@mantine/core";
import { OrderList } from "../OrderList/OrderList";
import { useTranslation } from "react-i18next";
import { useSession } from "../../auth/SessionContext";
import { TrialBanner } from "../TrialBanner/TrialBanner";
import { EmailPreview } from "../EmailPreview/EmailPreview";

const isDev = process.env.NODE_ENV === "development";

export default function ProfileContent(): React.JSX.Element {
  const { t } = useTranslation("translation");
  const { sessionData } = useSession();
  return (
    <Container size="lg" py="xl">
      <Stack gap="md">
        <Group justify="space-between" align="center">
          <Title order={2}>
            {t("account.title")}
            {sessionData?.name ? `: ${sessionData.name}` : ""}
          </Title>
          {isDev && <EmailPreview />}
        </Group>
        <TrialBanner variant="card" />
        <OrderList />
      </Stack>
    </Container>
  );
}
